import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { BrandingData } from "admin-portal/settings/branding";


import { LoginParam } from "models/user/login-param";
import { ResetPasswordParam } from "models/user/reset-password-param";

import { User } from "models/user/user";
import { StatusResponse } from "models/status-response";
import { UserRole } from "models/user/user-role";


export async function UserLogin(param: LoginParam) {

    return await WebAPIClient.postData<User>(ApiEndPoints.user_signIn, param, {
        tenantIdentifier: BrandingData.domain
    });
}
export async function UserLoginWithTwoFactor(param: LoginParam) {
    return await WebAPIClient.postData<User>(ApiEndPoints.user_signIn_OTP, param);
}

export async function UserForgetPassword(param: ResetPasswordParam) {
    return await WebAPIClient.postData<StatusResponse>(ApiEndPoints.user_forget_password, param);
}

export async function UserResetPassword(param: ResetPasswordParam) {
    return await WebAPIClient.postData<StatusResponse>(ApiEndPoints.user_reset_password, param);
}

export async function UserChangePassword(param: ResetPasswordParam) {
    return await WebAPIClient.postData<StatusResponse>(ApiEndPoints.user_change_password, param);
}



export async function GetUserRoles() {
    return await WebAPIClient.getData<UserRole[]>(ApiEndPoints.user_roles);
}

